import { Message } from '@components';

const STATUS_LABELS = {
  pending: 'Waiting...',
  saving: 'Saving...',
  success: 'Success',
  error: 'Failed',
};
const STATUS_COLORS = {
  pending: '#888',
  saving: 'var(--sb-blue-600, #1c64f2)',
  success: 'var(--sb-green-400, #2e7d32)',
  error: 'var(--sb-red-500, #c62828)',
};

// what a site's edit will actually end up as - only known once its current
// draft state has been fetched (see BulkUpdateWebsite.onPublish), so this is
// null for rows still 'pending'
const ACTION_TYPE_LABELS = {
  draft: 'Draft',
  publish: 'Publish',
};

// one row per site being bulk-saved, live status as the loop in
// BulkUpdateWebsite.onPublish works through them
export const BulkUpdateProgress = ({ rows, submitModeLabel, onStartOver }) => {
  const totalCount = rows.length;
  const completedCount = rows.filter(
    (row) => row.status === 'success' || row.status === 'error',
  ).length;
  const isDone = totalCount > 0 && completedCount === totalCount;
  const successCount = rows.filter((row) => row.status === 'success').length;
  const failureCount = rows.filter((row) => row.status === 'error').length;
  const currentNumber = Math.min(completedCount + 1, totalCount);

  return (
    <div className="sb-manage-content">
      {submitModeLabel && (
        <p style={{ color: '#888', marginBottom: '12px' }}>
          Submit mode: <strong>{submitModeLabel}</strong>
        </p>
      )}
      <Message
        messageStyle={isDone ? (failureCount ? 'error' : 'success') : 'notice'}
        fadeoutMessage={false}
        isFormMessage={false}
        title={
          isDone
            ? `Complete - ${successCount} succeeded${failureCount ? `, ${failureCount} failed` : ''}`
            : `Saving ${currentNumber}/${totalCount} website${totalCount != 1 ? 's' : ''}...`
        }
      />
      <ul style={{ listStyle: 'none', padding: 0, marginTop: '16px' }}>
        {rows.map((row) => (
          <li
            key={row.siteID}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: '8px 0',
              borderBottom: '1px solid var(--sb-gray-200, #e5e5e5)',
            }}
          >
            <span>{row.siteLabel}</span>
            <span
              style={{ display: 'flex', gap: '12px', alignItems: 'center' }}
            >
              {row.actionType && (
                <span
                  style={{
                    fontSize: '0.85em',
                    color: '#888',
                    border: '1px solid var(--sb-gray-200, #e5e5e5)',
                    borderRadius: '4px',
                    padding: '2px 6px',
                  }}
                >
                  {ACTION_TYPE_LABELS[row.actionType]}
                </span>
              )}
              <span style={{ color: STATUS_COLORS[row.status] }}>
                {STATUS_LABELS[row.status]}
              </span>
            </span>
          </li>
        ))}
      </ul>
      {isDone && (
        <div className="sb-manage-content-button-bar">
          <div className="sb-flex">
            <button
              type="button"
              className="sb-btn sb-btn-save"
              onClick={onStartOver}
            >
              Start new bulk update
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
